
<search-input-row placeholderText="{{'Search bots' | translate}}" (onAdd)="openAddModal()"
                    (onSearchVarUpdate)="botsFilter.name = $event" [roundedCorners]="false" [bottomSpacing]="false">
</search-input-row>
<div class="row mb-3" *ngIf="!isReady">
    <div class="col text-center">
        <i class="fad fa-spinner-third fa-spin"></i>
    </div>
</div>
<div class="rows-list row no-gutters determinants" *ngIf="isReady"
        cdkDropList
        [cdkDropListConnectedTo]="['item-mandatory']"
        [cdkDropListData]="bots | filterBy: botsFilter"
        (cdkDropListDropped)="dropped($event)">
    <div cdkDrag class="nglist-item col-12"
            *ngFor="let bot of bots | filterBy: botsFilter; let bagIndex = index">
        <div [attr.data-id]="bot.id" class="nglist-item-content container">
            <span class="list-group-item-icon {{getInternalStatus(bot)}}" *ngIf="bot.botType === 'internal'" tooltip="{{'bots.internalBot' | translate}} - {{getInternalStatusTooltip(bot) | translate}}" placement="right"><i class="fa fa-network-wired"></i></span>
            <span class="list-group-item-icon" *ngIf="bot.botType === 'document'" tooltip="{{'bots.documentBot' | translate}}" placement="right"><i class="fa fa-file"></i></span>
            <span class="list-group-item-icon {{getMessageStatus(bot)}}" *ngIf="bot.botType === 'message'" tooltip="{{'bots.messageBot' | translate}} - {{getMessageStatusTooltip(bot) | translate}}" placement="right"><i class="fa fa-envelope"></i></span>
            <span class="list-group-item-icon {{getDataStatus(bot)}}" *ngIf="bot.botType === 'data'" tooltip="{{'bots.dataBot' | translate}} - {{getDataStatusTooltip(bot) | translate}}" placement="right"><i class="fa fa-database"></i></span>
            <span class="list-group-item-icon" *ngIf="bot.botType === 'link'" tooltip="{{bot.redirectUrl}}" placement="right"><i class="far {{bot.isEregistrationService ? 'fa-circle-nodes' : 'fa-link-simple'}}"></i></span>
            <span class="list-group-item-icon" *ngIf="bot.botType === 'system'" tooltip="{{'bots.systemBot' | translate}}" placement="right"><i class="fa fa-cog"></i></span>
            <span class="list-group-item-text text-left">{{bot.name}}</span>
            <div class="nglist-item-actions r" *ngIf="bot.botType !== 'system'">
                <span class="editBtn" (click)="openEditModal(bot)">{{'bot.list.edit' | translate}}</span>
            </div>
        </div>
    </div>
</div>
